import RenderOnlyIfAuthenticationHasInitialised from './RenderOnlyIfAuthenticationHasInitialised'
export default RenderOnlyIfAuthenticationHasInitialised